import { translate, translateFormatter } from '@/domains/core/localization/translate';
export const {
  addToCart,
  stockNotAvailable,
  freeMMDeliveryWithReturn,
  fastMMDeliveryWithReturn
} = translate({
  "addToCart": "Add to basket",
  "stockNotAvailable": "Product out of stock",
  "fastMMDeliveryWithReturn": "Livraison en 24h et retours gratuits par",
  "freeMMDeliveryWithReturn": "Livraison 48h gratuite et retours gratuits"
});
export const quantity = translateFormatter<{
  number: number;
}>([{
  "type": 0,
  "value": "Quantity : "
}, {
  "type": 1,
  "value": "number"
}], undefined, undefined, "en");